import { render, staticRenderFns } from "./InviteChip.vue?vue&type=template&id=33340d85&"
import script from "./InviteChip.vue?vue&type=script&lang=ts&"
export * from "./InviteChip.vue?vue&type=script&lang=ts&"
import style0 from "./InviteChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
